<app-vessel-info-details [animate.enter]="'reveal-enter'" />
